import React, {useEffect, useRef, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Commentaires} from './commentaires';
import Webcam from "react-webcam";
import {
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from 'reactstrap';

export const SuivisCommercial = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  const [demandes, setDemandes] = useState([]);
  const [commentaires, setCommentaires] = useState([]);
  const [selectedDemandeId, setSelectedDemandeId] = useState(null);
  const form = useRef(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch('https://applications.alphitan-system.tech/demande.php');
      const data = await response.json();
      setDemandes(data);
    } catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
    }
  };

  const submit = (e) => {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);

    // Convertir les données de FormData en un objet JSON
    const jsonData = {};
    for (let [key, value] of data.entries()) {
      jsonData[key] = value;
    }

    fetch('https://applications.alphitan-system.tech/Commentaire.php', {
      method: 'POST',
      body: JSON.stringify(jsonData), // Envoyer les données en tant que JSON
      headers: {
        'Content-Type': 'application/json'
      },
    })
      .then((res) => res.json())
      .then((json) => setCommentaires(json.commentaire));
  };

  const handleOpenModal = (demandeId) => {
    setSelectedDemandeId(demandeId);
    toggleModal();
  };

  return (
    <div className="container-fluid">
      <Navbar expand={true}>
        <NavbarBrand href="/">
          <img
            alt="logo-alphitan"
            src="https://www.alphitan.com/wp-content/uploads/2019/07/GROUP-Couleur2.png"
            style={{height: '55%', width: '70%'}}
          />
        </NavbarBrand>
        <NavbarToggler onClick={() => toggle()}/>
        <Collapse className="d-flex justify-content-end" isOpen={isOpen} navbar>
          <Nav navbar>
            <NavItem>
              <NavLink href="/">Accueil</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="/#/suivisCommercial">Suivis commercial</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
      {demandes.map((demande, index) => (
        <div className="col-md-6 mx-auto border border-black mt-5" key={index}>
          <div className="row text-center">
            <h5 className="col-md-12">Demande N°{demande.id}</h5>
            <span className="col-md-4 mx-auto">Adresse Client : y.renaux@alphitan.com</span>
            <h5 className="col-md-12 mx-auto text-warning ">
              État OT : {demande.ot_etat ? demande.ot_etat : "Aucun OT enregistré dans CIGESCO"}
            </h5>
            <h5 className="col-md-12 mx-auto text-danger fw-bold">{demande.priorite}</h5>
          </div>
          <div className="row p-2 text-center">
            <span className="col-md-4">
              {demande.client} / {demande.code_postal}
            </span>
            <span className="col-md-4 fw-bold">{demande.reference}</span>
            <div className="form-check col-md-2 mx-auto" style={{width: 'auto'}}>
              <label className="form-check-label" htmlFor="flexCheckIndeterminate">
                Pris en charge par le chef d'îlot
              </label>
              <input
                className="form-check-input bg-success"
                type="checkbox"
                value=""
                id="flexCheckChecked"
                checked={demande.vue_admin > 0}
                disabled
              />
            </div>
          </div>
          <span style={{margin: "10px", fontWeight: "bold"}}>Information provenant de Cigesco : </span>
          <div className="commentaire-cigesco">
            {demande.commentaire_cigesco ? (
              <textarea
                className="border border-black col-md-4"
                style={{margin: "10px"}}
                disabled={true}
              >
            {demande.commentaire_cigesco}
          </textarea>
            ) : (
              <textarea
                className="border border-black col-md-4"
                style={{margin: "10px"}}
                disabled={true}
              >
            "Aucune information"
          </textarea>
            )}
          </div>
          <Commentaires id={demande.id}/>

          <div className="submit-btn text-center p-2">
            <button type="button" className="btn btn-success" onClick={() => handleOpenModal(demande.id)}>
              Envoyer un commentaire
            </button>
            <Modal isOpen={modal} toggle={toggleModal} modalTransition={{timeout: 500}}>
              <ModalHeader toggle={toggleModal}>Ajouter un commentaire</ModalHeader>
              <ModalBody>
                <form className="form-group text-center" ref={form} onSubmit={submit}>
                  <span>Demande N°{selectedDemandeId}</span>
                  <input type="hidden" name="demandeId" value={selectedDemandeId}/>
                  <label className="float-start">Votre Nom :</label>
                  <input type="text" className="form-control" name="nom" id="nom" placeholder="Nom"/>
                  <label className="float-start">Votre commentaire :</label>
                  <input
                    type="text"
                    className="form-control"
                    name="commentaire"
                    id="commentaire"
                    placeholder="Commentaire"
                  />
                  <button type="submit" className="btn btn-success mt-2" onClick={toggleModal}>
                    Envoyer un Commentaire
                  </button>
                </form>
              </ModalBody>
            </Modal>
          </div>
        </div>
      ))}
    </div>
  );
};
